import {
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
  styled,
} from "@mui/material";
import { Controller } from "react-hook-form";

const CustomBorderTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #3a3a3a;
    }
  }
`;

const ReactTextInput = (props) => {
  const {
    hookFormControl,
    label,
    formLabel,
    varName,
    isMultiLine = false,
    disabled = false,
    dataType = "text",
    rows = 4,
    errorMessage = null,
    autoFocus = false,
    helperText = null,
    size = "small",
    inputProps = null,
    startAdornment = null,
    endAdornment = null,
    variant = "outlined",
    width = "100%",
    withMessage = true,
    placeholder = "",
    maxLength = undefined,
    required = false,
  } = props;

  return (
    <>
      <FormControl
        error={errorMessage !== null}
        sx={{ width }}
        size={size}
        variant={variant}
      >
        {formLabel && (
          <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">
            {formLabel}
          </FormLabel>
        )}
        <Controller
          name={varName}
          control={hookFormControl}
          render={({ field }) => (
            <>
              {maxLength && (
                <div className="text-right font-['Poppins-Regular'] text-[12px] pr-2">
                  {field.value?.length ?? 0}/{maxLength}
                </div>
              )}
              <CustomBorderTextField
                id={varName}
                type={dataType}
                label={label}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                placeholder={placeholder}
                variant={variant}
                multiline={isMultiLine}
                InputProps={{
                  endAdornment,
                  startAdornment,
                  readOnly: props?.readOnly,
                  className:
                    "font-['Poppins-Regular'] text-[15px] border-[#3A3A3A]",
                }}
                InputLabelProps={{
                  className: "font-['Poppins-Regular'] text-[15px]",
                }}
                size={size}
                inputProps={{
                  ...inputProps,
                  min: dataType === "number" ? 0 : undefined,
                }}
                rows={rows}
                {...field}
                value={field.value ?? ""}
                onChange={(e) => {
                  let value = e.target.value;

                  if (maxLength && value.length > maxLength) {
                    value = value.slice(0, maxLength); // Trim the value if it exceeds maxLength
                  }

                  if (dataType === "number") {
                    value = value === "" ? "" : Math.max(0, Number(value));
                  }

                  field.onChange(value);
                }}
              />
            </>
          )}
        />
        {!errorMessage && helperText && withMessage && (
          <FormHelperText
            className="ml-0 font-['Poppins-Regular']"
            id="component-info-text"
          >
            {helperText}
          </FormHelperText>
        )}
        {errorMessage && withMessage && (
          <FormHelperText
            className="ml-0 font-['Poppins-Regular']"
            id="component-error-text"
          >
            {errorMessage}
          </FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default ReactTextInput;
